import React from 'react';
import {Component} from 'react';
import {connect} from 'react-redux';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';
import ReactTable from "react-table";
import "react-table/react-table.css";

import VATPreview from './VATPreview';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import Pagination from '../../page/Pagination';

const log = new Logger('FILING_DRILLDOWN_MODAL', LOG_LEVELS.DEBUG);
const DEFAULT_MODAL_CLASS =  {
    modal: 'modal-full-width modal-max-width-75'
  }; 
class DrilldownModal extends Component {

    onCloseClick(){
        this.props.onClose();
    }
    render() {
        log.debug('render(): props: ', this.props);
        return(
            <div>
                <Modal 
                       center 
                       open={this.props.open} 
                       onClose={() => this.onCloseClick()} 
                       classNames={this.props.modalStyles}
                        >
                    <h2>{this.props.title}</h2>
                    <br/>
                    <s-row>
                        <s-col span="12">
                            <ReactTable
                                data={this.props.data} 
                                columns={this.props.cols}
                                noDataText={LANGUAGES_CONTROLLER.format(this.props.languages, 'filingValuesDrillDownModal_NoData')}
                                loading={this.props.loading} 
                                className="mb15" 
                                minRows={0} 
                                maxRows={0}
                                defaultPageSize={10} 
                                showPagination={true} 
                                PaginationComponent={Pagination} 
                                showPageJump={false}
                            />
                        </s-col>                        
                    </s-row>
                </Modal>
            </div>
        );
    }
}


function mapStateToProps(state) {
    const stateProps = {
        languages: state.languages
    };

    return stateProps;
}

function mapDispatchToProps(dispatch) {

    const dispatchProps = {

    };
    return dispatchProps;

}

DrilldownModal.defaultProps = {
    modalStyles: DEFAULT_MODAL_CLASS
  }

export default connect(mapStateToProps, mapDispatchToProps)(DrilldownModal);